import { memo } from 'react';
import { Skeleton } from '@mui/material';
import styles from '../../publicationDetail.module.scss';
import { PublicationCharacteristicsProps } from '../../interfaces';

const PublicationCharacteristics = ({
  publication,
  loading
}: PublicationCharacteristicsProps) => {
  if (!publication?.caracteristics) return null;

  const renderCharacteristicRow = (item: any, index: number) => (
    <tr key={index} className={styles.item}>
      <td className={styles.icon}>
        <img src={`${item?.icon}`} alt={item?.name} />
      </td>
      <th className={styles.name}>{item?.name}</th>
      <td className={styles.value}>
        {loading ? (
          <Skeleton animation="wave" variant="text" className={styles.skeleton} />
        ) : (
          item?.value ?? "-"
        )}
      </td>
    </tr>
  );

  const renderDesktopCharacteristics = () => {
    return publication.caracteristics.map((item: any, index: number) => {
      if (index > 3) return null;
      return (
        <tr key={index} className={styles.item}>
          <td className={styles.icon}>
            <img src={`${item?.icon}`} alt={item?.name} />
          </td>
          <th className={styles.name}>{item?.name}</th>
          <td className={styles.value}>
            {loading ? (
              <Skeleton animation="wave" variant="text" className={styles.skeleton} />
            ) : (
              item?.value ?? "-"
            )}
          </td>
          <td className={styles.icon}>
            <img src={`${publication?.caracteristics[index + 4]?.icon}`} alt={publication?.caracteristics[index + 4]?.name} />
          </td>
          <th className={styles.name}>{publication?.caracteristics[index + 4]?.name}</th>
          <td className={styles.value}>
            {loading ? (
              <Skeleton animation="wave" variant="text" className={styles.skeleton} />
            ) : (
              publication?.caracteristics[index + 4]?.value ?? "-"
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <div className={styles.table}>
      <p className={styles.region}>{publication?.region}</p>
      <div className={styles.comparaContainer}>
        <p className={styles.title}>Características</p>
      </div>
      <table>
        <tbody>
          {window.innerWidth <= 1024 
            ? publication.caracteristics.map(renderCharacteristicRow)
            : renderDesktopCharacteristics()
          }
        </tbody>
      </table>
    </div>
  );
};

export default memo(PublicationCharacteristics);
